<script>
  import { createEventDispatcher } from "svelte";

  //liblary
  import axios from "axios";

  import { session, notif } from "../components/js/notif.js";
  let settings;
  session.subscribe((value) => {
    settings = value;
  });

  let _token = localStorage.getItem("t");

  const dispatch = createEventDispatcher();

  export let jumlahorder;
  export let id;
  function cartDelete() {
    axios
      .post(settings.url + "/sipade/cart?authorization=" + settings.token, {
        productID: id,
        delete: true,
      })
      .then(function (response) {
        jumlahorder = parseInt(jumlahorder) || 1;
        dispatch("message", {
          text: jumlahorder,
        });
        load_notif();
      })
      .catch(function (error) {
        window.location.reload();
        if (error.response.status == 401) {
          localStorage.removeItem("t");
        }
      });
  }
  function load_notif() {
    if (_token) {
      axios
        .get(settings.url + "/sipade/notif", {
          params: {
            authorization: _token,
          },
        })
        .then(function (response) {
          notif.update((n) => response.data.notif);
        });
    }
  }
</script>

<i
  on:click|preventDefault={cartDelete}
  on:click
  class="cursor-pointer select-none p-1 rounded-full text-xs text-red-600 text-center
transform transition-all duration-300 scale-100 hover:scale-110 m-r-2
h-8 outline-none flex items-center justify-center">[hapus]</i>
